import styled from "styled-components";

export const ServiceItemStyles = styled.div`
  display: flex;
  align-items: center;

  .startDate {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: rgba(86, 86, 86, 0.6);
  }

  .finishDate {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: rgba(0, 102, 68, 0.6);
  }

  .index {
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .user {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .userName {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .msgBadge {
    align-self: flex-start;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    padding: 2px 6px;
    border-radius: 999px;
    background: ${({ theme }) => theme.colors.error[50]};
    color: ${({ theme }) => theme.colors.error[600]};
    text-transform: uppercase;
    letter-spacing: 0.4px;
    white-space: nowrap;
  }

  .serviceTypeText {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vehicleLine {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workers {
    display: flex;
    align-items: center;
  }

  .notAssigned {
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .avatarStack {
    display: flex;
    align-items: center;

    & > * + * {
      margin-left: -8px;
    }
  }

  .moreBadge {
    margin-left: 4px;
    min-width: 28px;
    height: 28px;
    padding: 0 6px;
    border-radius: 999px;
    background: ${({ theme }) => theme.colors.accent[100]};
    color: ${({ theme }) => theme.colors.accent[700]};
    font-size: 11px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${({ theme }) => theme.colors.semantic.container.white};
  }
`;
